import "./instrument.js";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { MantineProvider } from '@mantine/core';

import reportWebVitals from './reportWebVitals';
import { store } from 'src/store';
import App from './App';

import '@common/i18n/config';
import { setupEnvironment } from './helpers/setupEnvironment';

import './index.scss';
import packageJson from './../../../package.json';
import '@fortawesome/fontawesome-free/css/all.min.css';


console.log('%c IALabs app version: ' + packageJson.version, 'color: #50C878');

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'widget-component': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}

setupEnvironment().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

  root.render(
    // <React.StrictMode>
      <Provider store={store}>
        <MantineProvider withNormalizeCSS withGlobalStyles>
          <App />
        </MantineProvider>
      </Provider>
    // </React.StrictMode>,
  );

  reportWebVitals();
});
